export const ComingSoon = (
    callback,
    allowCallback = false,
    _alert = 'Em breve esta função estará disponível'
) => {
    if (allowCallback && callback) {
        callback?.();
        return;
    }
    alert(_alert)
}